export default ({ axios, mapQueryString }) => ({
    index: (branch, query = {}) => axios.get(`/branches/${branch}/categories${mapQueryString(query)}`),
    update: (branch, body) => axios.patch(`/branch-categories/${branch}`, body)
})



// WEBPACK FOOTER //
// ./src/api/branchCategories.js